import { render, staticRenderFns } from "./hs-text.vue?vue&type=template&id=16f4bd0a&scoped=true"
import script from "./hs-text.ts?vue&type=script&lang=ts&external"
export * from "./hs-text.ts?vue&type=script&lang=ts&external"
import style0 from "./hs-text.scss?vue&type=style&index=0&id=16f4bd0a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f4bd0a",
  null
  
)

export default component.exports